import FeaturedImage from '@/components/FeaturedImage';
import TrainerVerified from './TrainerVerified';
import TrainerInfo from './TrainerInfo';
import TrainerEmail from './TrainerEmail';
import TrainerCity from './TrainerCity';
import TrainerActions from './TrainerActions';
import { trainerDefaultProps, trainerPropTypes } from './TrainerShape';

const defaultProps = {
  ...trainerDefaultProps,
};

const propTypes = {
  ...trainerPropTypes,
};

export default function TrainerCard({ title, featuredImage, info, social }) {
  const hasEmail = social.email !== null;
  const hasCity = info.city !== null;

  return (
    <div className="flex flex-col">
      <div className="border-b-8 border-green-500 relative">
        <FeaturedImage
          className="rounded-t-lg w-full"
          alt={title}
          {...featuredImage.node}
        />
      </div>
      <div className="divide-y p-6 space-y-4">
        <div className="space-y-1">
          <h2 className="font-semibold text-2xl flex items-center space-x-2">
            <div>{title}</div>
            <TrainerVerified />
          </h2>
          {hasEmail && <TrainerEmail email={social.email} />}
          {hasCity && <TrainerCity city={info.city} />}
        </div>
        <TrainerInfo {...info} />
        <TrainerActions {...social} />
      </div>
    </div>
  );
}

TrainerCard.defaultProps = defaultProps;
TrainerCard.propTypes = propTypes;
